<template>
    <div class="b1t-okraina-cart">
        <div class="container">
            Корзина
        </div>
    </div>
</template>

<script>
    export default {
        name: 'b1t-okraina-cart'
    }
</script>

<style lang="scss">
    
</style>